import langFromUrl from 'lib/util/langFromUrl';

function __environ() {
  return '';
}

export default function buildGoTo(tda, redirectPath) {
  // 5/9 release: We need /en only for domain-restructured domains that use a site-context of 'en'
  if ('/en/' === redirectPath || '/es/' ===  redirectPath) { redirectPath = '/'; }

  // Strip the site context from the redirectPath, otherwise the GOTO URL will be wrong:
  // example:   /GOTO/BOS10/socal/dealers/index.page?zipcode=90015&deep=show
  // and therefore redirect will look something like this:
  // https://www.buyatoyota.com/newengland/socal/dealer-detail/?dealercode=20126&deep=show
  // which will give a 404
  if (redirectPath && redirectPath.length > 1) {
    // list of TDAs
    var tdas = ['home', 'socal', 'norcal', 'pacificnorthwest', 'southeasttoyota', 'mi-oh-ky-tn',
      'central', 'midwest', 'newengland', 'westernwashington', 'greaterny',
      'upstateny', 'connecticut', 'tristateeast', 'tristate', 'denver',
      'centralatlantic', 'phoenix', 'inlandnorthwest', 'sandiego', 'gst', 'goldcoast'];

    // only substr part of the redirect path if it contains the site context
    for (var i = 0; i < tdas.length; i += 1) {
      if (redirectPath.indexOf(tdas[i]) >= 0) {
        // redirect path is like this (english): /socal/dealer-detail/?dealercode=20126&deep=show
        // get the position of the 2nd fwd slash
        var startPosition = redirectPath.indexOf('/', redirectPath.indexOf('/') + 1);

        // if Spanish, start after the second slash after /es
        if (redirectPath.substr(0, 3) === '/es') {
          startPosition = redirectPath.indexOf('/', redirectPath.indexOf('/') + 4);
        }

        // now get the substr of the rest of the path, starting from the 2nd slash,
        // which is right after the site context
        if (startPosition > 0) {
          redirectPath = redirectPath.substr(startPosition, redirectPath.length);
        }
        break;
      }
    }
  }

  var gotourl = '/GOTO/' + tda + __environ() + redirectPath;
  if ('es' === langFromUrl()) {
    gotourl = '/GOTO/' + tda + '/es' + redirectPath; // 5/9 we always need this /es though!
  }

  return gotourl;
};
